export const appealTypes = {
  0: 'DREF',
  1: 'Appeal',
  2: 'Movement',
  3: 'EAP Activation'
};

export const appealTypeOptions = [
  { value: 'all', label: 'All Appeal Types' },
  { value: '0', label: 'DREF' },
  { value: '1', label: 'Emergency Appeals' },
  { value: '2', label: 'Movement' },
  { value: '3', label: 'Early Action Protocol (EAP) Activation'}
];
